var chunkMapping = {
	"564": [
		22564
	]
};
var idToExternalAndNameMapping = {
	"22564": [
		"default",
		"./module",
		53284
	]
};
var idToRemoteMap = {
	"22564": [
		{
			"externalType": "script",
			"name": "spclaims_management"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"22564": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 53284,
		"remoteName": "spclaims_management"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}